<template>
  <div class="container-fluid">
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px"
      >
        <h2 style="flex: 1">Transaction History</h2>
      </div>
      <vue-good-table
        :lineNumbers="true"
        :columns="fields"
        :rows="transactionHistory"
        @on-page-change="onPageChange"
        @on-per-page-change="onPerPageChange"
        :totalRows="total"
        :pagination-options="{ 
					enabled: true
				}"
      >
        <template slot="table-row" slot-scope="props" style="background: red;">
					<span v-if="props.column.field == 'transactionReference'" >
						{{props.row.transactionReference ? props.row.transactionReference : "----"}}
					</span>						

          <span v-if="props.column.field == 'fullName'" >
						{{props.row.user ? `${props.row.user.firstName} ${props.row.user.lastName}` : "----"}}
          </span>

					<span v-if="props.column.field == 'amountPaid'"  >
						{{props.row.actualAmount ? `NGN ${(props.row.actualAmount).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}` : "----"}}
          </span>

					<span v-if="props.column.field == 'paymentStatus'" class="center-svg">
            <span v-if="props.row.status">
              {{props.row.status == "success" ? `Success - **** **** **** ${props.row.detail && props.row.detail.card && props.row.detail.card.last_4digits} (${(props.row.detail && props.row.detail.card && props.row.detail.card.type).toString().charAt(0).toUpperCase() +	(props.row.detail && props.row.detail.card && props.row.detail.card.type).toString().substr(1).toLowerCase()})` : "Failed transaction" }}
            </span>
            <span v-else>
							- - - - 
						</span>
					</span>

          <span v-if="props.column.field == 'paymentTime'" >
            <span v-if="props.row.createdAt">
              {{ formatDate(props.row.createdAt) }} {{ formatTime(props.row.createdAt) }}
            </span>
            <span v-else>
							- - - - 
						</span>
					</span>	
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import moment from "moment";
moment.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

export default {
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      fields: [
        {
          field: "transactionReference",
          label: "Transaction Ref",
          sortable: "true"
        },
        {
          field: "fullName",
          label: "Name",
          sortable: "true"
        },
        {
          field: "amountPaid",
          label: "Amount",
          sortable: "true"
        },
        {
          field: "paymentStatus",
          label: "Transaction Status",
          sortable: "true"
        },
        {
          field: "paymentTime",
          label: "Date & Time",
          sortable: "true"
        }
      ],
      transactionHistory: "",
			total: "",
			serverParams: {
        perPage: 10,
        page: 1
      },
    };
  },
  computed: {
    ...mapGetters(["getUserById", "getDummy", "getUserSession"]),
  },
  methods: {
    formatDate(date) {
      return moment(date).format("Do MMMM, YYYY");
    },
    formatTime(date) {
      return moment(date).format("hh:mm a");
    },
		updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.init();
    },
    onPerPageChange(params) {			
      this.updateParams({perPage: params.currentPerPage});
      this.init();
    },
    init() {
			const httpUtils = this.$httpUtils;
      let url = `/transactionHistories/user`;

			httpUtils.instance.get(url+`?skip=${(this.serverParams.page-1)*this.serverParams.perPage}&limit=${this.serverParams.perPage}`)
      .then(response => {
        this.transactionHistory = response.data[0]
				this.total = response.data[1].total
      })
      .catch(error => {
        console.log("transactionUrl error", error)
        this.showErrorMsg({message: "Error occured at our end!"}); 
      });		
    }
  },
  async mounted() {
    this.init();
  }
};
</script>

<style scoped>
.card-title {
  font-size: 2.6rem;
}

.center-svg {
	display: flex;
	margin: 0px auto;  
}

table th,
table th span {
  font-size: 0.7em;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/billing/TransactionHistory.vue